/**
 * The "What product…?" question that opens a PDP request. Its text used to be the
 * only hint that an image could answer it, so it now carries a button for each way
 * to give the product: upload, paste, the File Browser, or typing an id. (POR-15158)
 *
 * No imports, so the page and the store can both use it without a cycle.
 */

// Kept from when the widget held only "Or start from a brief →": the brief flow
// (brief-picker.js, NetworksPageV2) finds the question by this id.
export const PDP_PRODUCT_ASK_WIDGET_ID = 'pdp_from_brief';

export const PDP_PRODUCT_ASK_ACTIONS = {
  upload: 'pdp_product_upload',
  paste: 'pdp_product_paste',
  browse: 'pdp_product_browse',
  type: 'pdp_product_type',
};

const PRODUCT_ASK_HINT = 'Add a product image with the buttons below, or type an ASIN, Salsify ID, GTIN or product name in the chat.';

/** The question's text — `subject` is what is being made ("a PDP image set"). */
export function pdpProductAskText(subject = 'a PDP image set') {
  return `What product would you like to create ${subject} for? ${PRODUCT_ASK_HINT}`;
}

/** The fallback question when nothing says what is being made. */
export function pdpProductAskGenericText() {
  return `What product would you like to use? ${PRODUCT_ASK_HINT}`;
}

export function isPdpProductAskAction(action) {
  return Object.values(PDP_PRODUCT_ASK_ACTIONS).includes(action);
}

/**
 * The buttons under the question. `isSet` is the request it answers (an image set
 * or a single image), so a click can resume it even once the parked intent is gone
 * (a reload, or backing out of the brief picker).
 */
export function pdpProductAskWidget(isSet = true) {
  return {
    type: 'action_buttons',
    id: PDP_PRODUCT_ASK_WIDGET_ID,
    pdpIntent: { isSet: !!isSet },
    buttons: [
      { label: 'Upload image', iconClass: 'bi bi-upload', action: PDP_PRODUCT_ASK_ACTIONS.upload, variant: 'primary' },
      { label: 'Paste image', iconClass: 'bi bi-clipboard', action: PDP_PRODUCT_ASK_ACTIONS.paste, variant: 'light' },
      { label: 'Choose from Files', iconClass: 'bi bi-folder2-open', action: PDP_PRODUCT_ASK_ACTIONS.browse, variant: 'light' },
      { label: 'Enter ASIN or ID', iconClass: 'bi bi-upc-scan', action: PDP_PRODUCT_ASK_ACTIONS.type, variant: 'light' },
      { label: 'Or start from a brief →', action: 'from_brief_open', variant: 'light' },
    ],
  };
}
